import { IconProps } from '../../Icon.types';

export const Event3DIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_3982_59683)">
        <path
          d="M31.4016 4.80005C34.8434 4.80005 36.5184 5.12351 38.2594 6.0546C39.8442 6.90216 41.0987 8.15668 41.9462 9.74147C42.8773 11.4825 43.2008 13.1575 43.2008 16.5992V31.4009C43.2008 34.8426 42.8773 36.5176 41.9462 38.2586C41.0987 39.8434 39.8442 41.0979 38.2594 41.9455C36.5184 42.8766 34.8434 43.2001 31.4016 43.2001H16.5999C13.1582 43.2001 11.4832 42.8766 9.74221 41.9455C8.15741 41.0979 6.90289 39.8434 6.05534 38.2586C5.12424 36.5176 4.80078 34.8426 4.80078 31.4009V16.5992C4.80078 13.1575 5.12424 11.4825 6.05534 9.74147C6.90289 8.15668 8.15741 6.90216 9.74221 6.0546C11.4832 5.12351 13.1582 4.80005 16.5999 4.80005H31.4016ZM31.4016 8.40005H16.5999C13.7017 8.40005 12.5881 8.61509 11.44 9.22913C10.4825 9.74117 9.7419 10.4818 9.22986 11.4392C8.61582 12.5874 8.40078 13.701 8.40078 16.5992V31.4009C8.40078 34.2991 8.61582 35.4127 9.22986 36.5609C9.7419 37.5183 10.4825 38.2589 11.44 38.771C12.5881 39.385 13.7017 39.6001 16.5999 39.6001H31.4016C34.2999 39.6001 35.4134 39.385 36.5616 38.771C37.519 38.2589 38.2597 37.5183 38.7717 36.5609C39.3857 35.4127 39.6008 34.2991 39.6008 31.4009V16.5992C39.6008 13.701 39.3857 12.5874 38.7717 11.4392C38.2597 10.4818 37.519 9.74117 36.5616 9.22913C35.4134 8.61509 34.2999 8.40005 31.4016 8.40005ZM27.0008 30C27.9949 30 28.8008 30.8059 28.8008 31.8001C28.8008 32.7942 27.9949 33.6 27.0008 33.6H16.2008C15.2067 33.6 14.4008 32.7942 14.4008 31.8001C14.4008 30.8059 15.2067 30 16.2008 30H27.0008ZM31.8008 22.2001C32.7949 22.2001 33.6008 23.0059 33.6008 24C33.6008 24.9942 32.7949 25.8 31.8008 25.8H16.2008C15.2067 25.8 14.4008 24.9942 14.4008 24C14.4008 23.0059 15.2067 22.2001 16.2008 22.2001H31.8008ZM31.8008 14.4C32.7949 14.4 33.6008 15.2059 33.6008 16.2C33.6008 17.1942 32.7949 18 31.8008 18H16.2008C15.2067 18 14.4008 17.1942 14.4008 16.2C14.4008 15.2059 15.2067 14.4 16.2008 14.4H31.8008Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3982_59683"
          x="3.80078"
          y="4.80005"
          width="39.4004"
          height="39.3999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3982_59683"
          />
        </filter>
      </defs>
    </svg>
  );
};
